module.exports = __webpack_public_path__ + "img/icon_sportMenu_fives.c5ef71d6.svg";